var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgAnalyzingLoader = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#analyzing-loader_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M20.009 8.272a3.706 3.706 0 1 0 0-7.413 3.706 3.706 0 0 0 0 7.413Z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.1,
  d: "M9.093 12.784a3.704 3.704 0 0 0 2.621-6.329 3.706 3.706 0 1 0-2.621 6.329Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.273 19.991a3.706 3.706 0 1 0-7.413 0 3.706 3.706 0 0 0 7.413 0Z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.8,
  d: "M6.46 28.287a3.706 3.706 0 1 0 5.24 5.24 3.706 3.706 0 0 0-5.24-5.24Z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.7,
  d: "M19.991 31.727a3.706 3.706 0 1 0 0 7.412 3.706 3.706 0 0 0 0-7.412Z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.6,
  d: "M28.287 28.3a3.711 3.711 0 0 0 0 5.242 3.706 3.706 0 1 0 0-5.242Z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M35.434 16.3a3.706 3.706 0 1 0 0 7.413 3.706 3.706 0 0 0 0-7.412Z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.4,
  d: "M30.92 12.797a3.696 3.696 0 0 0 2.62-1.084 3.711 3.711 0 1 0-2.62 1.084Z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "analyzing-loader_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h40v40H0z"
})))));
export default SvgAnalyzingLoader;